export default __webpack_public_path__ + "static/bunker-fonts-38dc45ab8e0f924aed6c26356b506b53.jpg";